

// ####################################################################################

// import React, { useState, useEffect } from "react";
// import { ToastContainer, toast } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";

// const ITEMS_PER_PAGE = 5;

// const user = JSON.parse(localStorage.getItem("user"));

// function TravelEditTable({ data, onUpdate, onClose, onRefreshCount }) {
//   const [requests, setRequests] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);

//   useEffect(() => {
//     if (!data) return;

//     const filtered = data.filter((r) => {
//       if (user.role === "Admin") return r.status === 1;
//       if (user.role === "Finance Manager") return r.status === 2;
//       return true;
//     });

//     const withAction = filtered.map((r) => ({
//       ...r,
//       tempAction: 1, // default action: approve
//     }));

//     setRequests(withAction);
//   }, [data]);

//   const totalPages = Math.ceil(requests.length / ITEMS_PER_PAGE);
//   const currentItems = requests.slice(
//     (currentPage - 1) * ITEMS_PER_PAGE,
//     currentPage * ITEMS_PER_PAGE
//   );

//   const handleChange = (index, field, value) => {
//     const updated = [...requests];
//     const actualIndex = (currentPage - 1) * ITEMS_PER_PAGE + index;

//     updated[actualIndex][field] =
//       field === "price" || field === "tempAction"
//         ? parseInt(value)
//         : value;

//     setRequests(updated);
//   };

//   const handleSave = async (req) => {
//     const action = req.tempAction;
//     const payload = {
//       price: req.price,
//       role: user.role,
//       action,
//     };

//     try {
//       const res = await fetch(
//         `${process.env.REACT_APP_API_BASE_URL}/travel_request/${req.request_id}`,
//         {
//           method: "PUT",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         }
//       );

//       if (!res.ok) throw new Error("Failed to update");

//       toast[action < 0 ? "error" : "success"](
//         action < 0 ? "Request rejected" : "Request approved"
//       );

//       await onUpdate();         // ✅ Fetch updated request list
//       onRefreshCount?.();       // ✅ Optional refresh of count
//     } catch (err) {
//       console.error("❌ Update failed", err);
//       toast.error("Failed to process request");
//     }
//   };

//   const Pagination = () => (
//     <div className="flex justify-center mt-4 space-x-1 text-xs text-gray-700">
//       {Array.from({ length: totalPages }, (_, i) => (
//         <button
//           key={i}
//           className={`px-2 py-1 border rounded ${
//             currentPage === i + 1
//               ? "bg-blue-500 text-white"
//               : "bg-white hover:bg-gray-100"
//           }`}
//           onClick={() => setCurrentPage(i + 1)}
//         >
//           {i + 1}
//         </button>
//       ))}
//     </div>
//   );

//   return (
//     <div className="p-4 overflow-x-auto">
//       <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} />
//       <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm rounded shadow">
//         <thead className="bg-gray-100 text-gray-700">
//           <tr>
//             <th className="border p-2">Request ID</th>
//             <th className="border p-2">Employee</th>
//             <th className="border p-2">Project</th>
//             <th className="border p-2">Source</th>
//             <th className="border p-2">Destination</th>
//             <th className="border p-2">Date</th>
//             <th className="border p-2">Price</th>
//             <th className="border p-2">Approve / Reject</th>
//             <th className="border p-2">Action</th>
//           </tr>
//         </thead>
//         <tbody>
//           {currentItems.map((req, i) => (
//             <tr key={req.request_id} className="hover:bg-gray-50">
//               <td className="border p-2 text-center">{req.request_id}</td>
//               <td className="border p-2">{req.employee_name}</td>
//               <td className="border p-2">{req.project_name}</td>
//               <td className="border p-2">{req.source}</td>
//               <td className="border p-2">{req.destination}</td>
//               <td className="border p-2">
//                 {new Date(req.date).toLocaleDateString()}
//               </td>
//               <td className="border p-2">
//                 <input
//                   type="number"
//                   value={req.price || ""}
//                   onChange={(e) => handleChange(i, "price", e.target.value)}
//                   className="border rounded px-2 py-1 w-20 text-sm"
//                 />
//               </td>
//               <td className="border p-2">
//                 <select
//                   value={req.tempAction}
//                   onChange={(e) =>
//                     handleChange(i, "tempAction", e.target.value)
//                   }
//                   className="border rounded px-2 py-1 text-sm"
//                 >
//                   {user.role === "Admin" ? (
//                     <>
//                       <option value={1}>Approve</option>
//                       <option value={-1}>Reject</option>
//                     </>
//                   ) : user.role === "Finance Manager" ? (
//                     <>
//                       <option value={1}>Approve</option>
//                       <option value={-2}>Reject</option>
//                     </>
//                   ) : (
//                     <option value={1}>Approve</option>
//                   )}
//                 </select>
//               </td>
//               <td className="border p-2 text-center">
//                 <button
//                   onClick={() => handleSave(req)}
//                   className="bg-blue-500 hover:bg-blue-600 text-white text-xs px-3 py-1 rounded shadow"
//                 >
//                   Save
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>

//       <Pagination />

//       <div className="text-center mt-4">
//         <button
//           onClick={onClose}
//           className="bg-gray-500 hover:bg-gray-600 text-white px-2 py-1 rounded text-sm"
//         >
//           Back to Chat
//         </button>
//       </div>
//     </div>
//   );
// }

// export default TravelEditTable;




import React, { useState, useEffect } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const ITEMS_PER_PAGE = 5;

const getUserFromStorage = () => {
  try {
    return JSON.parse(localStorage.getItem("user")) || {};
  } catch {
    return {};
  }
};

function TravelEditTable({ data, onUpdate, onClose, onRefreshCount }) {
  const [user, setUser] = useState({});
  const [requests, setRequests] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const storedUser = getUserFromStorage();
    if (storedUser?.role) {
      setUser(storedUser);
    }
  }, []);

  useEffect(() => {
    if (!data || !user?.role) return;

    const filtered = data.filter((r) => {
      if (user.role === "Admin") return r.status === 1;
      if (user.role === "Finance Manager") return r.status === 2;
      return true;
    });

    const withAction = filtered.map((r) => ({
      ...r,
      tempAction: 1,
    }));

    setRequests(withAction);
  }, [data, user]);

  const totalPages = Math.ceil(requests.length / ITEMS_PER_PAGE);
  const currentItems = requests.slice(
    (currentPage - 1) * ITEMS_PER_PAGE,
    currentPage * ITEMS_PER_PAGE
  );

  const handleChange = (index, field, value) => {
    const updated = [...requests];
    const actualIndex = (currentPage - 1) * ITEMS_PER_PAGE + index;

    updated[actualIndex][field] =
      field === "price" || field === "tempAction"
        ? parseInt(value)
        : value;

    setRequests(updated);
  };

  const handleSave = async (req) => {
    const action = req.tempAction;
    const payload = {
      price: req.price,
      role: user.role,
      action,
    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/travel_request/${req.request_id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Failed to update");

      toast[action < 0 ? "error" : "success"](
        action < 0 ? "Request rejected" : "Request approved"
      );

      await onUpdate();
      onRefreshCount?.();
    } catch (err) {
      console.error("❌ Update failed", err);
      toast.error("Failed to process request");
    }
  };

  const Pagination = () => (
    <div className="flex justify-center mt-4 space-x-1 text-xs text-gray-700">
      {Array.from({ length: totalPages }, (_, i) => (
        <button
          key={i}
          className={`px-2 py-1 border rounded ${
            currentPage === i + 1
              ? "bg-blue-500 text-white"
              : "bg-white hover:bg-gray-100"
          }`}
          onClick={() => setCurrentPage(i + 1)}
        >
          {i + 1}
        </button>
      ))}
    </div>
  );

  if (!user?.role) {
    return (
      <div className="p-4 text-red-600 font-semibold">
        Invalid user session. Please log in again.
      </div>
    );
  }

  return (
    <div className="p-4 overflow-x-auto">
      <ToastContainer position="top-right" autoClose={1000} hideProgressBar={false} />
      <table className="min-w-full table-auto border-collapse border border-gray-300 text-sm rounded shadow">
        <thead className="bg-gray-100 text-gray-700">
          <tr>
            <th className="border p-2">Request ID</th>
            <th className="border p-2">Employee</th>
            <th className="border p-2">Project</th>
            <th className="border p-2">Source</th>
            <th className="border p-2">Destination</th>
            <th className="border p-2">Date</th>
            <th className="border p-2">Price</th>
            <th className="border p-2">Approve / Reject</th>
            <th className="border p-2">Action</th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((req, i) => (
            <tr key={req.request_id} className="hover:bg-gray-50">
              <td className="border p-2 text-center">{req.request_id}</td>
              <td className="border p-2">{req.employee_name}</td>
              <td className="border p-2">{req.project_name}</td>
              <td className="border p-2">{req.source}</td>
              <td className="border p-2">{req.destination}</td>
              <td className="border p-2">
                {new Date(req.date).toLocaleDateString()}
              </td>
              <td className="border p-2">
                <input
                  type="number"
                  value={req.price || ""}
                  onChange={(e) => handleChange(i, "price", e.target.value)}
                  className="border rounded px-2 py-1 w-20 text-sm"
                />
              </td>
              <td className="border p-2">
                <select
                  value={req.tempAction}
                  onChange={(e) => handleChange(i, "tempAction", e.target.value)}
                  className="border rounded px-2 py-1 text-sm"
                >
                  {user.role === "Admin" ? (
                    <>
                      <option value={1}>Approve</option>
                      <option value={-1}>Reject</option>
                    </>
                  ) : user.role === "Finance Manager" ? (
                    <>
                      <option value={1}>Approve</option>
                      <option value={-2}>Reject</option>
                    </>
                  ) : (
                    <option value={1}>Approve</option>
                  )}
                </select>
              </td>
              <td className="border p-2 text-center">
                <button
                  onClick={() => handleSave(req)}
                  className="bg-blue-500 hover:bg-blue-600 text-white text-xs px-3 py-1 rounded shadow"
                >
                  Save
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      <Pagination />

      <div className="text-center mt-4">
        <button
          onClick={onClose}
          className="bg-gray-500 hover:bg-gray-600 text-white px-2 py-1 rounded text-sm"
        >
          Back to Chat
        </button>
      </div>
    </div>
  );
}

export default TravelEditTable;



